module.exports = __webpack_public_path__ + "img/avatar-default-icon.0a99ce4f.webp";